import { DeleteOutlined, EditOutlined } from '@icon';
import { Table } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { actions } from '../../../store/ducks/tags-page';
import { ModalState, TagItem } from '../../../types/tags-page';

interface ListDialogProps {
  tag: TagItem;
}

const TagAction: React.FC<ListDialogProps> = ({ tag }) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  return (
    <Table.Actions
      items={[
        {
          key: 'edit',
          label: formatMessage({ id: 'tags_edit' }),
          Icon: EditOutlined,
          onClick: () => {
            dispatch(actions.setActiveTag(tag));
            dispatch(actions.setModalStatus(ModalState.opened));
          },
        },
        {
          key: 'delete',
          label: formatMessage({ id: 'tags_remove' }),
          Icon: DeleteOutlined,
          variant: 'danger',
          onClick: () => {
            dispatch(actions.setActiveTag(tag));
            dispatch(actions.setDeleteModalStatus(ModalState.opened));
          },
        },
      ]}
    />
  );
};

export default React.memo(TagAction);
